import React, { useState } from "react";
import {
  FaAndroid,
  FaChartLine,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import { TagComponent } from "../Tabs";
const ProjectionReport = () => {
  const [activeTab1, setActiveTab1] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];
  const content1 = {
    web: "",
    mobile: "",
  };


  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow-md"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaChartLine className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">          Projection Report</h1>
      </div>


       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
         <div className="flex flex-wrap gap-3">
           <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
           <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
         </div>
         <div className="flex flex-wrap gap-3">
           <TagComponent icon={<FaGlobe />} label="Web" color="green" />
           <TagComponent icon={<FaAndroid />} label="Android" color="green" />
         </div>
       </div>
      <p className="text-start mb-6 text-gray-600 ">
        Your wholesale customers frequently add products to their order carts.
        Because every item added is saved immediately, they can continue
        updating their carts daily but place their orders whenever
        convenient—whether that’s once, twice a month, or as needed.
        <br />
        To help you plan production and purchases accurately, our one-click
        projection report automatically totals all order carts from your
        wholesale customers, providing a clear summary of quantities for each
        product and size.
      </p>

      <div className="my-5">
        {renderTabs(activeTab1, setActiveTab1)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={content1[activeTab1]}
            alt={`${activeTab1} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectionReport;
